import * as yup from 'yup'
import { mapValues } from 'lodash'

import { AnyObject, YupConfig } from 'data/Common'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { PassTier } from 'data/PassTier'
import { RootState } from 'redux/store'
import { createSelector } from 'reselect'
import { createYupSchema } from 'utils/yupSchemaCreator'

interface PassTierState {
    chosenPassTier: PassTier | null
    formValues: AnyObject
    formDataForValidationSchema: YupConfig[]
}

export const initialState: PassTierState = {
    formValues: {},
    chosenPassTier: null,
    formDataForValidationSchema: [],
}

const passTierSlice = createSlice({
    name: 'passTier',
    initialState,
    reducers: {
        resetState: _ => initialState,
        clearChosenPassTier: state => {
            state.chosenPassTier = null
            state.formValues = mapValues(state.formValues, () => '')
        },
        chosenPassTierHasSoldOut: state => {
            state.chosenPassTier = state.chosenPassTier ? { ...state.chosenPassTier, isSoldOut: true } : null
        },
        setChosenPassTier: (state, { payload: passTier }: PayloadAction<PassTier>) => {
            state.chosenPassTier = passTier
        },
        setFormValues: (state, { payload: formValues }: PayloadAction<AnyObject>) => {
            state.formValues = { ...state.formValues, ...formValues }
        },
        setFormDataForValidationSchema: (
            state,
            { payload: formDataForValidationSchema }: PayloadAction<YupConfig[]>,
        ) => {
            state.formDataForValidationSchema = formDataForValidationSchema
        },
    },
})

const { actions, reducer } = passTierSlice

export default reducer

export const getPassTier = (store: RootState) => store.passTier

export const getChosenPassTier = createSelector(getPassTier, tier => tier.chosenPassTier)

export const getFormValues = createSelector(getPassTier, tier => tier.formValues)

export const getValidationSchema = createSelector(getPassTier, tier =>
    yup.object().shape(tier.formDataForValidationSchema.reduce(createYupSchema, {})),
)

export const {
    resetState,
    setFormValues,
    setChosenPassTier,
    setFormDataForValidationSchema,
    clearChosenPassTier,
    chosenPassTierHasSoldOut,
} = actions
